module.exports = __webpack_public_path__ + "img/promotion.91633e1c.svg";